import React, { useMemo } from "react";
import "antd/dist/antd.css";
import { Form, Input, Collapse } from "antd";
import { connect } from "react-redux";
import * as actions from "../../Store/Actions/index";
import { formatNumber, getHelp, getValidateStatus } from "../../Util/util";
import { getInfoForRole, getWagePlusBenefitsForRole } from "../Logics/retrainCalculations";
import { getFracProdLoss } from "../Logics/prodLossCalculations";
import { getLabel } from "../../Util/util";
import {
  icd11codingTimeInitialTooltip,
  icd11codingTimeFinalTooltip,
  breakInPeriodTooltip,
  workingDaysPerMonthTooltip,
} from "../../Util/writing";
import { getIcon } from "../../Util/iconUtil";
const lodash = require("lodash");

const { Panel } = Collapse;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 11 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
  },
};

const inputFormDivStyle = {
  border: "1px solid #ebedf0",
  borderRadius: "2px",
  marginTop: "5px",
  marginLeft: "20px",
  marginRight: "20px",
  marginBottom: "5px",
  backgroundColor: "white",
  padding: "10px",
};

const ProductivityLoss = (props) => {
  const coderNumber = useMemo(() => lodash.get(getInfoForRole("coder"), "number"), [props.retrainCostDetails]);
  const coderWage = useMemo(() => lodash.get(getInfoForRole("coder"), "wage"), [props.retrainCostDetails]);
  const coderBenefit = useMemo(() => lodash.get(getInfoForRole("coder"), "benefit"), [props.retrainCostDetails]);
  const coderWagePlusBen = getWagePlusBenefitsForRole("coder");

  const updateProdLossAttr = (e) => {
    const inputField = e.currentTarget.id;
    const value = e.currentTarget.value;
    props.setProdLossAttr({ [inputField]: value });
  };

  return (
    <React.Fragment>
      {/* Input */}

      <div style={inputFormDivStyle}>
        <Form {...formItemLayout}>
          <Collapse expandIcon={() => getIcon("coder", "role")}>
            <Panel
              header={"Coder (pre-populated from previous tab)"}
              key={"coder-fields-prod-loss"}
              extra={formatNumber(coderWagePlusBen) + " " + props.currency}
            >
              <Form.Item label={getLabel("Full-Time Equivalent Coders")} help="">
                <Input
                  disabled
                  addonAfter="Persons"
                  placeholder=""
                  id="full-time-equivalent-coders"
                  value={coderNumber}
                />
              </Form.Item>

              <Form.Item label={getLabel("Hourly Wage of Coders")} help="">
                <Input
                  disabled
                  addonAfter={props.currency}
                  placeholder=""
                  id="hourly-wage-of-coders"
                  value={coderWage}
                />
              </Form.Item>

              <Form.Item label={getLabel("Hourly Benefits Amount")} help="">
                <Input disabled addonAfter={props.currency} placeholder="" id="benefit-hourly" value={coderBenefit} />
              </Form.Item>

              <Form.Item label="Hourly Wage Plus Benefits" help="">
                <Input
                  disabled
                  addonAfter={props.currency}
                  placeholder=""
                  id="wage-plus-benefits"
                  value={formatNumber(coderWagePlusBen)}
                />
              </Form.Item>
            </Panel>
          </Collapse>

          <Collapse expandIcon={() => getIcon(props.prodLossDetails, "prodChange")}>
            <Panel header={"Productivity Change"} key={"prod-change"}>
              <Form.Item
                required
                label={getLabel("Predicted Initial Coding Time per Inpatient Chart", icd11codingTimeInitialTooltip)}
                help={getHelp(props.prodLossDetails["coding-time-a"])}
                validateStatus={getValidateStatus(props.prodLossDetails["coding-time-a"])}
              >
                <Input
                  addonAfter="Minutes"
                  placeholder=""
                  id="coding-time-a"
                  onChange={updateProdLossAttr}
                  value={props.prodLossDetails["coding-time-a"]}
                />
              </Form.Item>

              <Form.Item
                required
                label={getLabel("Predicted Final Coding Time per Inpatient Chart", icd11codingTimeFinalTooltip)}
                help={getHelp(props.prodLossDetails["coding-time-b"])}
                validateStatus={getValidateStatus(props.prodLossDetails["coding-time-b"])}
              >
                <Input
                  addonAfter="Minutes"
                  placeholder=""
                  id="coding-time-b"
                  onChange={updateProdLossAttr}
                  value={props.prodLossDetails["coding-time-b"]}
                />
              </Form.Item>

              <Form.Item label="Percent Reduction in Productivity" help="">
                <Input
                  disabled
                  addonAfter="%"
                  placeholder=""
                  id="percent-reduction-productivity"
                  value={formatNumber(getFracProdLoss() * 100)}
                />
              </Form.Item>
            </Panel>
          </Collapse>

          <Collapse expandIcon={() => getIcon(props.prodLossDetails, "prodLossTimeline")}>
            <Panel header={"Timeline"} key={"prod-timeline"} id="timelinePanel">
              <Form.Item
                label="Working Hours In A Day"
                help={getHelp(props.prodLossDetails["working-hours-per-day"])}
                validateStatus={getValidateStatus(props.prodLossDetails["working-hours-per-day"])}
                required
              >
                <Input
                  addonAfter="Hours"
                  placeholder=""
                  id="working-hours-per-day"
                  onChange={updateProdLossAttr}
                  className="numberInput"
                  value={props.prodLossDetails["working-hours-per-day"]}
                />
              </Form.Item>

              <Form.Item
                label={getLabel("Minimum Break-in Period", breakInPeriodTooltip)}
                help={getHelp(props.prodLossDetails["min-break-in-period"])}
                validateStatus={getValidateStatus(props.prodLossDetails["min-break-in-period"])}
                required
              >
                <Input
                  addonAfter="Months"
                  placeholder=""
                  id="min-break-in-period"
                  onChange={updateProdLossAttr}
                  className="numberInput"
                  value={props.prodLossDetails["min-break-in-period"]}
                />
              </Form.Item>

              <Form.Item
                label={getLabel("Maximum Break-in Period", breakInPeriodTooltip)}
                help={getHelp(props.prodLossDetails["max-break-in-period"])}
                validateStatus={getValidateStatus(props.prodLossDetails["max-break-in-period"])}
                required
              >
                <Input
                  addonAfter="Months"
                  placeholder=""
                  id="max-break-in-period"
                  onChange={updateProdLossAttr}
                  className="numberInput"
                  value={props.prodLossDetails["max-break-in-period"]}
                />
              </Form.Item>

              <Form.Item
                label={getLabel("Working Days per Month", workingDaysPerMonthTooltip)}
                help={getHelp(props.prodLossDetails["working-days-per-month"])}
                validateStatus={getValidateStatus(props.prodLossDetails["working-days-per-month"])}
                required
              >
                <Input
                  addonAfter="Days"
                  placeholder=""
                  id="working-days-per-month"
                  onChange={updateProdLossAttr}
                  className="numberInput"
                  value={props.prodLossDetails["working-days-per-month"]}
                />
              </Form.Item>
            </Panel>
          </Collapse>
        </Form>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    currency: state.currency.currency,
    retrainCostDetails: state.costs.retrainCostDetails,
    prodLossDetails: state.costs.prodLossDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setProdLossAttr: (obj) => dispatch(actions.setProdLossAttr(obj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductivityLoss);
